import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { SubSink } from 'subsink';
var LoginComponent = (function () {
    function LoginComponent(authService, activatedRoute, router) {
        this.authService = authService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.uiStatus = 'login';
        this.errorMessage = null;
        this.subs = new SubSink();
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        localStorage.clear();
        this.subs.add(this.activatedRoute.params.subscribe(function (params) {
            _this.errorMessage = params.msg || null;
        }));
    };
    LoginComponent.prototype.tryAgain = function () {
        this.uiStatus = 'login';
        this.email = null;
    };
    LoginComponent.prototype.login = function () {
        var _this = this;
        this.errorMessage = null;
        if (_.isNil(this.email)) {
            this.errorMessage = 'โปรดกรอกข้อมูลให้ครบถ้วน';
            return;
        }
        this.uiStatus = 'loading';
        this.subs.add(this.authService.requestOtp(this.email).subscribe(function (response) {
            _this.uiStatus = 'succeed';
        }, function (error) {
            if (error != null && error.status === 400) {
                _this.uiStatus = 'failed';
                _this.errorMessage = error.error.detail;
            }
        }));
    };
    LoginComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return LoginComponent;
}());
export { LoginComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/login/login.component.ts.pre-build-optimizer.js